// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/yfos-promise-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../images/yfos-otp-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../images/laptop-yfos-otp-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../images/down-arrow.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../images/laptop-yfos-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../images/small-laptop-yfos-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.booking-confirmation-main-wrapper {
  margin-top: 25px;
  /* margin-bottom: 20px; */
}

.booking-confirmation-main-wrap {
  border: 2px solid #f8f8f8;
  border-radius: 34px;
  /* min-height: 72vh; */
  padding: 30px;
}

.booking-confirmation-main-wrap {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
}

.booking-cart-wrapper {
  border-right: 1px solid #e1e1e1;
  padding-right: 16px;
}

.booking-details-wrapper {
  border-right: 1px solid #e1e1e1;
  padding-right: 36px;
}

.booking-cart-head {
  display: flex;
  align-items: center;
  gap: 10px;
}

.booking-cart-head img {
  width: 28px;
  cursor: pointer;
}

.booking-cart-head img:hover {
  transform: scale(0.9);
}

.booking-cart-head h4 {
  font-size: 18px;
  color: #1a1919;
  font-weight: bold;
  margin: 0px;
}

.booking-squarefeet-wrap {
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.booking-squarefeet-wrap p {
  font-size: 14px;
  color: #1a1919;
  font-weight: 400;
  margin: 0px;
}

.booking-squarefeet-wrap span {
  font-size: 14px;
  color: #1a1919;
  font-weight: 500;
  margin: 0px;
}

.booking-cart-items-wrap {
  margin-top: 24px;
}

.booking-cart-items-wrap h5 {
  font-size: 14px;
  color: #1a1919;
  font-weight: 600;
  margin: 0px;
}

.booking-cart-item-repeat {
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
}

.booking-cart-item-left {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 10px;
}

span.additional-dropdown-type {
  font-weight: 600;
  margin-right: 10px;
}

.booking-item-image {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #f3f3f3;
  overflow: hidden;
}

.booking-item-image img {
  width: 100%;
  object-fit: cover;
}

.booking-cart-flooring-wrap {
  margin-top: 12px;
}

.booking-item-detail {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 5px;
}

.booking-item-detail h6 {
  font-size: 14px;
  color: #1a1919;
  font-weight: 600;
  white-space: nowrap;
  margin: 0px;
}

.booking-item-detail p {
  font-size: 14px;
  color: #1a1919;
  font-weight: 400;
  margin: 0px;
}

.booking-item-detail span {
  font-size: 14px;
  color: #00a19b;
  font-weight: 400;
  margin-top: 2px;
}

.booking-cart-item-right {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.update-quantity-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: #f3f3f3;
  border-radius: 12px;
  min-width: 95px;
  padding: 2px;
}

.update-quantity-btn h4 {
  font-size: 14px;
  color: #ff0000;
  font-weight: 600;
  margin: 0px;
  cursor: pointer;
}

.update-quantity-btn span {
  width: 20px;
  text-align: center;
  font-size: 14px;
  color: #1a1919;
  font-weight: 600;
  margin: 0px;
}

.update-quantity-btn span.percentage-text {
  width: 30px;
  text-align: center;
}

.update-quantity-btn h4.increment-btn-text {
  color: #20cb00;
}

.booking-item-price-wrap p {
  font-size: 14px;
  color: #1a1919;
  font-weight: 400;
  margin: 0px;
  min-width: 60px;
}

.booking-cart-item-repeat {
  margin-bottom: 16px;
}

.booking-industry-floor-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0px;
  margin-top: 22px;
}

.booking-industry-floor-wrap p {
  font-size: 14px;
  color: #00a19b;
  font-weight: 600;
  margin: 0px;
  padding-right: 6px;
  line-height: normal;
}

.booking-detail-address-wrap {
  margin-top: 25px;
}

.booking-detail-address {
  margin-top: 17px;
}

.booking-detail-address p {
  font-size: 12px;
  color: #626262;
  font-weight: 400;
  margin: 0px;
}

.booking-detail-address h6 {
  font-size: 14px;
  color: #1a1919;
  font-weight: 500;
  padding-top: 4px;
  overflow: hidden;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  word-break: break-word;
}

.contact-person-heading {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 16px;
}

.contact-person-heading h4 {
  font-size: 14px;
  color: #1a1919;
  font-weight: 600;
  margin: 0px;
}

.contact-person-detail-wrap {
  margin-top: 50px;
}

.contact-person-booking-detail {
  margin-top: 32px;
}

.yfos-promise-main-wrap {
  width: 100%;
  height: 247px;
  border: 1px solid #f3f3f3;
  border-radius: 9px;
  padding: 24px 43px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-repeat: no-repeat;
}

.yfos-promise-otp-main-wrap {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  background-repeat: no-repeat;
  padding: 22px 43px;
}

.yfos-promise-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.yfos-promise-head-left h3 {
  font-size: 30px;
  color: #1a1919;
  font-weight: 600;
  margin: 0px;
}

.yfos-promise-head-left h4 {
  font-size: 20px;
  color: #6b6b6b;
  font-weight: 600;
  margin: 0px;
}

.yfos-promise-head-right img {
  width: 110px;
}

.yfos-promise-list-wrap {
  display: flex;
  gap: 24px;
  flex-direction: column;
  margin-top: 26px;
}

.yfos-promise-list-repeat {
  display: flex;
  align-items: center;
  gap: 10px;
}

.yfos-promise-list-repeat p {
  font-size: 14px;
  color: #626262;
  font-weight: 400;
  margin: 0px;
}

.yfos-promise-otp-main-wrap {
  text-align: center;
}

.commercial-yfos-otp img {
  width: 66px;
}

.commercial-otp-heading h3 {
  font-size: 16px;
  color: #1a1919;
  font-weight: 600;
  margin: 0px;
}

.commercial-otp-heading {
  display: flex;
  gap: 6px;
  align-items: center;
  justify-content: center;
  margin-bottom: 18px;
  margin-top: 16px;
}

.commercial-otp-heading img {
  width: 10px;
  height: 10px;
  cursor: pointer;
}

.pay-modal-term-wrapper.yfos-otp-access-wrap {
  width: 70%;
  height: 37px;
  border: 1px solid #f3f3f3;
  border-radius: 11px;
  padding: 0px 20px;
  margin: 0 auto;
  margin-top: 10px;
  cursor: pointer;
}

.pay-modal-term-wrapper.yfos-otp-access-wrap.active {
  border: 1px solid #00a19b;
}

.yfos-otp-access-wrap .term-modal-checkmark-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 37px;
  gap: 0px;
  margin-bottom: 0px;
}

.yfos-otp-access-wrap .term-modal-checkmark-wrap p {
  font-size: 12px;
  color: #00a19b;
  font-weight: 500;
  margin: 0px;
}

.yfos-otp-access-wrap .checkbox-container .checkmark {
  position: absolute;
  top: -10px;
  right: -6px;
  left: unset;
  height: 18px;
  width: 18px;
  background-color: #f3f3f3;
  border-radius: 0px;
  border: none;
  border-radius: 50%;
}

.yfos-otp-access-wrap .checkbox-container .checkmark:after {
  left: 7px;
  top: 3px;
  width: 5px;
  height: 10px;
}

.payment-saved-card-info {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 62px;
}

.add-payment-card-info {
  justify-content: space-between;
}

.payment-saved-card-info img {
  width: 35px;
}

.payment-saved-card-info p {
  font-size: 12px;
  color: #1a1919;
  font-weight: 500;
  margin: 0px;
}

.payment-saved-card-wrap {
  width: 100%;
  height: 62px;
  border: 1px solid #f3f3f3;
  border-radius: 9px;
  margin-top: 10px;
  padding: 0px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.payment-save-card-right p {
  font-size: 12px;
  color: #1a1919;
  font-weight: 500;
  margin: 0px;
}

.payment-save-card-right img {
  width: 25px;
}

.add-card-left-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.add-card-left-wrap img {
  width: 34px;
}

.postpaid-payment-left-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
}

.postpaid-payment-main-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #f3f3f3;
  border-radius: 9px;
  background: #f3f3f3;
  padding: 0px 20px;
  height: 62px;
  margin-top: 12px;
}

.approved-postpaid-payment-main-wrap {
  background-color: #fff;
  border: 1px solid #f3f3f3;
  cursor: pointer;
}

.approved-postpaid-payment-main-wrap.active {
  border: 1px solid #00a19b;
}

.postpaid-payment-left-wrap img {
  width: 30px;
}

.postpaid-payment-left-wrap p {
  font-size: 12px;
  color: #1a1919;
  font-weight: 500;
  margin: 0px;
}

.postpaid-payment-right-wrap p {
  font-size: 12px;
  color: #00a19b;
  font-weight: 500;
  margin: 0px;
  cursor: pointer;
}

.postpaid-payment-right-wrap {
  display: flex;
  gap: 24px;
}

.get-veried-now {
  display: flex;
  align-items: center;
  gap: 6px;
}

.offer-and-benefits-wrap {
  margin-top: 12px;
  /* margin-top: 20px; */
}

.offer-and-benefits-wrap h4 {
  font-size: 14px;
  color: #1a1919;
  font-weight: 500;
  padding-left: 10px;
  margin: 0px;
}

.apply-coupon-wrap {
  width: 100%;
  height: 62px;
  border: 1px solid #f3f3f3;
  border-radius: 9px;
  padding: 0px 20px;
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

/* .apply-coupon-wrap:hover{
    border: 1px solid #00A19B;
} */

.apply-coupon-wrap p {
  font-size: 12px;
  color: #1a1919;
  font-weight: 500;
  margin: 0px;
}

.apply-coupon-wrap img {
  width: 7px;
}

.payment-method-detail-wrap {
  margin-top: 18px;
  border-bottom: 1px dashed #e1e1e1;
}

.payment-detail-left p {
  font-size: 14px;
  color: #1a1919;
  font-weight: 500;
  margin: 0px;
}

.payment-detail-right p {
  font-size: 14px;
  color: #626262;
  font-weight: 400;
  margin: 0px;
}

.payment-detail-repeat {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 8px;
}

.payment-detail-right {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  text-align: right;
  gap: 2px;
}

.payment-method-price-detail-wrap {
  margin-top: 12px;
  margin-bottom: 12px;
}

.payment-detail-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.payment-detail-left h4 {
  font-size: 16px;
  color: #1a1919;
  font-weight: 600;
  margin: 0px;
}

.payment-detail-right h4 {
  font-size: 16px;
  color: #00a19b;
  font-weight: 600;
  margin: 0px;
}

span.extra-item-size-text {
  font-weight: 500;
  color: #1a1919;
  margin-left: 3px;
}

.edit-extra-item-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  background: #daf6f6;
  border-radius: 12px;
  min-width: 95px;
  padding: 2px;
}

.edit-extra-item-btn p {
  font-size: 14px;
  font-weight: 600;
  color: #1a1919;
  margin: 0px;
}

.additional-dropdown-shows {
  display: flex;
  flex-direction: column;
  text-align: left;
  align-items: flex-start;
  justify-content: flex-start;
}

.mobile-text {
  display: none;
}

.cart-drawer-main-wrapper .decrement-btn-text img {
  width: 20px;
  height: 17px;
}

.contact-person-heading img {
  cursor: pointer;
  width: 10px;
  height: 10px;
}

.payment-detail-left img {
  cursor: pointer;
}

.payment-saved-card-wrap.active {
  border: 1px solid #00a19b;
}

.payment-saved-card-wrap {
  cursor: pointer;
}

.payment-schedule-date {
  display: flex;
  align-items: center;
  gap: 0px;
}

/* .exterior-window-li {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
} */

.exterior-dropdown-type-main-wrap li {
  list-style: none;
  margin-right: 10px;
}

.exterior-dropdown-type-main-wrap {
  /* display: flex;
    justify-content: space-between;
    width: 100%; */
}

.number-of-window {
  margin-top: 10px;
}

p.exterior-service-head {
  font-size: 16px;
  color: #00a19b;
}

.specialty-booking-item-detail {
  display: flex;
  flex-direction: column;
}

.payment-detail-repeat.total-payment-detail-repeat {
  background: #fff;
  margin-bottom: 0px;
  padding-bottom: 8px;
}


img.payment-method-postpaid-icon{
  width: 18px;
  margin-right: 4px
}


img.payment-method-cart-icon{
  margin-top: -3px;
}

.payment-saved-card-wrap:hover{
  border: 1px solid #00a19b;
}

.approved-postpaid-payment-main-wrap:hover{
  border: 1px solid #00a19b;
}

.apply-coupon-wrap:hover{
  border: 1px solid #00a19b; 
}


/******* Resposive css ****/
@media (max-width: 1024px) {
  .booking-confirmation-main-wrap {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 18px;
    border: unset;
    border-radius: 0px;
    min-height: unset;
    padding: 0px;
  }

  .yfos-promise-main-wrapper {
    display: none;
  }

  .yfos-promise-otp-main-wrapper {
    display: block;
  }

  .yfos-promise-otp-main-wrap {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: cover;
    background-repeat: no-repeat;
    padding: 20px;
    height: 154px;
    margin-top: 20px;
    /* margin-bottom: 10px; */
  }

  .commercial-otp-heading h3 {
    font-size: 14px;
  }

  .pay-modal-term-wrapper.yfos-otp-access-wrap {
    width: 90%;
    margin-top: 12px;
  }

  .commercial-otp-heading {
    margin-bottom: 12px;
    margin-top: 0px;
  }

  .commercial-yfos-otp {
    display: none;
  }

  .booking-details-wrapper {
    border-right: unset;
    padding-right: 0px;
    /* margin-top: 30px; */
    margin-top: 10px;
  }

  .booking-cart-head h4 {
    font-size: 18px;
    font-weight: 600;
  }

  .contact-person-booking-detail .field {
    position: relative;
    width: 100%;
    margin-bottom: 14px;
  }

  .payment-detail-left p {
    min-width: 80px;
  }

  .payment-detail-right {
    text-align: right;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .payment-detail-repeat {
    align-items: flex-start;
  }

  .booking-confirmation-main-wrapper {
    margin-bottom: 40px;
  }

  .payment-detail-right img {
    width: 25px;
  }

  .pay-mobile-button-wrapper {
    margin-top: 22px;
    position: sticky;
    z-index: 999;
    bottom: 80px;
    background: #fff;
    padding-top: 10px;
    padding-bottom: 10px;
    border-top: 1px solid #cccccc40;
  }

  .pay-button-wrapper button {
    height: 62px;
    font-size: 18px;
  }

  .payment-method-detail-wrap {
    margin-top: 26px;
    padding-bottom: 6px;
  }

  .desktop-text {
    display: none;
  }

  .mobile-text {
    display: block;
  }

  .offer-and-benefits-wrap {
    margin-top: 26px;
  }

  .postpaid-payment-right-wrap {
    gap: 10px;
  }

  .postpaid-payment-left-wrap img {
    width: 34px;
  }

  .contact-person-heading {
    /* margin-bottom: 10px; */
    margin-bottom: 16px;
  }

  .contact-person-booking-detail {
    margin-top: 40px;
  }

  .booking-detail-address {
    margin-top: 20px;
  }

  .booking-detail-address-wrap {
    margin-top: 32px;
  }

  .booking-cart-head img {
    width: 27px;
  }

  .booking-cart-items-wrap h5 {
    font-size: 18px;
  }

  .mobile-booking-cart-items-wrap {
    margin-top: 30px;
  }

  .mobile-booking-cart-items-wrap h5 {
    font-size: 18px;
    color: #1a1919;
    font-weight: 600;
    margin: 0px;
  }

  /********************** Select Services css *****/
  .accordion-item {
    margin-bottom: 16px;
  }

  .accordion-item .accordion-header .accordion-button {
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    padding: 10px 20px;
  }

  .accordion-button:not(.collapsed) {
    color: unset;
    background-color: unset;
    box-shadow: unset;
  }

  .accordion-item {
    border-radius: 9px;
    border: 1px solid #f3f3f3;
  }

  .accordion-item .accordion-collapse.collapse.show {
    border-top: none;
    border-bottom-left-radius: 9px;
    border-bottom-right-radius: 9px;
    transition: border-color 0.3s ease;
  }

  .accordion-button:not(.collapsed) {
    border-radius: 9px;
    border-bottom: none;
  }

  .accordion-button:focus {
    box-shadow: none;
  }

  .accordion-item:not(:first-of-type) {
    border-top: 1px solid #f3f3f3;
  }

  .accordion-item.active {
    border: 2px solid #00a19b;
  }

  button.accordion-button img {
    width: 56px;
    margin-right: 20px;
  }

  button.accordion-button {
    position: unset;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px !important;
    font-size: 14px;
    font-weight: 600;
    color: #1a1919 !important;
  }

  .accordion-item {
    position: relative;
    border-radius: 10px !important;
  }

  .accordion-button::after {
    position: absolute;
    bottom: -10px;
    right: 10px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  }

  .accordion-button:not(.collapsed)::after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  }

  .mobile-booking-cart-item-left {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .update-quantity-btn {
    width: 100px;
    gap: 16px;
  }

  .edit-extra-item-btn {
    width: 100px;
  }

  .edit-extra-item-btn p {
    font-weight: 500;
  }

  .booking-cart-item-repeat {
    display: flex;
    align-items: flex-start;
  }

  .booking-item-detail p {
    text-align: left;
    width: 100%;
  }

  .booking-squarefeet-wrap {
    margin-top: 30px;
    flex-direction: column;
    align-items: flex-start;
  }

  .booking-cart-flooring-wrap {
    margin-top: 14px;
  }

  .mobile-accordion-body-wrapper {
    margin-top: -8px;
  }

  .booking-industry-floor-wrap p {
    font-size: 14px;
  }
}

@media (max-width: 360px) {
}

@media (max-width: 330px) {
  .payment-detail-left p {
    min-width: 50px;
  }

  .payment-detail-right img {
    width: 24px;
  }

  .payment-detail-right {
    gap: 0px;
  }

  .postpaid-payment-right-wrap {
    gap: 2px;
  }

  .postpaid-payment-left-wrap {
    gap: 4px;
  }

  .postpaid-payment-right-wrap p {
    font-size: 10px;
  }

  .get-veried-now {
    gap: 3px;
  }

  .get-veried-now img {
    width: 4px;
  }
}
/* 
@media (min-width: 768px) and (max-width: 1024px) {
    .booking-confirmation-main-wrap {
        grid-template-columns: repeat(1, 1fr);
        gap: 20px;
        border-radius: 24px;
        padding: 30px 0px;
        border: none;
    }

    .booking-details-wrapper {
        padding-right: 0px;
        border-right: none;
    }

    .yfos-promise-main-wrap {
        display: none;
    }

    .booking-cart-wrapper {
        border-right: none;
        padding-right: 0px;
    }

    p.desktop-text {
        display: none;
    }

    .mobile-text {
        display: block;
    }

    .payment-detail-left {
        min-width: 100px;
    }

    .payment-detail-right {
        text-align: right;
    }

    .offer-and-benefits-wrap {
        margin-top: 16px;
    }
} */

@media (min-width: 1025px) and (max-width: 1599px) {
  .booking-confirmation-main-wrap {
    gap: 20px;
    border-radius: 24px;
    padding: 22px 20px;
    height: 525px;
    padding-right: 0px;
  }

  .booking-confirmation-main-wrapper {
    margin-top: 16px;
  }

  .booking-details-wrapper {
    padding-right: 20px;
  }

  .booking-cart-item-repeat {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 14px;
  }

  p.desktop-text {
    display: none;
  }

  .mobile-text {
    display: block;
  }

  .payment-detail-left {
    min-width: 50px;
  }

  .payment-detail-right {
    gap: 0px;
  }

  .payment-detail-right {
    text-align: right;
  }

  .offer-and-benefits-wrap {
    margin-top: 8px;
  }

  .yfos-promise-head-right img {
    width: 80px;
  }

  .yfos-promise-head-left h3 {
    font-size: 24px;
  }

  .yfos-promise-head-left h4 {
    font-size: 16px;
  }

  .yfos-promise-head-left {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .yfos-promise-list-wrap {
    margin-top: 15px;
    gap: 10px;
  }

  .yfos-promise-list-repeat img {
    width: 15px;
    height: 15px;
  }

  .yfos-promise-list-repeat p {
    font-size: 12px;
  }

  .yfos-promise-main-wrap {
    height: 150px;
    padding: 16px 36px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  }

  .yfos-promise-otp-main-wrap {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: cover;
    background-repeat: no-repeat;
    padding: 16px 20px;
  }

  .commercial-otp-heading h3 {
    font-size: 14px;
  }

  .pay-modal-term-wrapper.yfos-otp-access-wrap {
    width: 90%;
  }

  .commercial-otp-heading {
    margin-bottom: 10px;
    margin-top: 0px;
  }

  .commercial-yfos-otp {
    display: none;
  }

  .booking-cart-head h4 {
    font-size: 14px;
  }

  .booking-detail-address {
    margin-top: 16px;
  }

  .booking-cart-head {
    gap: 8px;
  }

  .booking-cart-head img {
    width: 22px;
  }

  .booking-squarefeet-wrap {
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .booking-cart-items-wrap {
    margin-top: 22px;
  }

  .booking-squarefeet-wrap span {
    font-size: 12px;
  }

  .booking-squarefeet-wrap p {
    font-size: 12px;
  }

  .booking-cart-items-wrap h5 {
    font-size: 12px;
  }

  .booking-item-detail h6 {
    font-size: 12px;
  }

  .booking-item-detail p {
    font-size: 12px;
  }

  .booking-cart-wrapper {
    min-height: 480px !important;
    overflow: auto;
  }

  .update-quantity-btn {
    min-width: 74px;
    padding: 2px;
  }

  .update-quantity-btn span {
    font-size: 10px;
  }

  .update-quantity-btn span.percentage-text {
    width: 22px;
  }

  .booking-item-price-wrap p {
    font-size: 12px;
  }

  .booking-industry-floor-wrap p {
    font-size: 12px;
  }

  .booking-industry-floor-wrap img {
    width: 22px;
  }

  .booking-industry-floor-wrap {
    margin-top: 10px;
  }

  .booking-detail-address-wrap {
    margin-top: 16px;
  }

  .booking-detail-address h6 {
    font-size: 12px;
  }

  .contact-person-heading h4 {
    font-size: 12px;
  }

  .contact-person-booking-detail {
    margin-top: 20px;
  }

  .contact-person-heading {
    margin-bottom: 10px;
  }

  .contact-person-booking-detail .field {
    margin-bottom: 16px;
  }

  .payment-saved-card-wrap {
    height: 48px;
  }

  .booking-payment-method-wrapper {
    position: relative;
    max-height: 500px;
    overflow: auto;
    padding-right: 20px;
  }

  .booking-payment-method-wrapper .pay-button-wrapper {
    position: sticky;
    bottom: 0px;
    width: 100%;
    background-color: #fff;
    padding-top: 6px;
    border-top: 1px solid #cccccc40;
  }

  /* .total-payment-detail-repeat{
    position: sticky;
    bottom: 80px;
    width: 100%;
    background-color: #fff; 
    padding-bottom: 10px;
    margin-bottom: 0px;
  } */

  .payment-saved-card-info img {
    width: 30px;
  }

  .payment-saved-card-info {
    gap: 6px;
    height: 48px;
  }

  .add-card-left-wrap img {
    width: 26px;
  }

  .add-card-left-wrap {
    gap: 5px;
  }

  .postpaid-payment-main-wrap {
    height: 48px;
    margin-top: 8px;
  }

  .apply-coupon-wrap {
    height: 48px;
    margin-top: 8px;
  }

  .offer-and-benefits-wrap h4 {
    font-size: 12px;
  }

  .payment-detail-left p {
    font-size: 12px;
  }

  .payment-detail-right p {
    font-size: 12px;
  }

  .payment-detail-left h4 {
    font-size: 14px;
  }

  .payment-detail-right h4 {
    font-size: 14px;
  }

  .payment-detail-repeat {
    margin-bottom: 4px;
  }

  .payment-method-detail-wrap {
    margin-top: 8px;
  }

  .payment-detail-right img {
    width: 22px;
    height: 22px;
  }

  img.payment-method-postpaid-icon {
    width: 18px;
    height: 18px;
    margin-right: 4px;
}

  .payment-method-price-detail-wrap {
    margin-top: 5px;
  }

  .pay-button-wrapper {
    margin-top: 8px;
  }

  .booking-confirmation-main-wrap .booking-cart-item-right-wrapper {
    width: 100%;
  }

  .booking-cart-item-right {
    justify-content: flex-end;
    text-align: right;
    gap: 0px;
  }

  .booking-item-detail span {
    font-size: 12px;
  }

  .payment-method-price-detail-wrap {
    margin-bottom: 0px;
  }
}

@media (min-width: 1025px) and (max-width: 1199px) {
  .yfos-promise-main-wrap {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  }

  .yfos-promise-otp-main-wrap {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }

  .booking-confirmation-main-wrap {
    gap: 10px;
    border-radius: 24px;
    padding: 16px 20px;
    padding-right: 0px;
  }

  .booking-details-wrapper {
    padding-right: 10px;
  }

  .booking-payment-method-wrapper {
    padding-right: 10px;
  }

  .payment-saved-card-info img {
    width: 22px;
  }

  .payment-saved-card-info p {
    font-size: 11px;
  }

  .payment-save-card-right p {
    font-size: 11px;
  }

  .payment-saved-card-info {
    gap: 2px;
  }

  .add-card-left-wrap img {
    width: 26px;
  }

  .add-card-left-wrap {
    gap: 2px;
  }

  .postpaid-payment-right-wrap p {
    font-size: 10px;
  }

  .postpaid-payment-left-wrap p {
    font-size: 11px;
  }

  .postpaid-payment-left-wrap {
    gap: 4px;
  }

  .postpaid-payment-right-wrap {
    gap: 10px;
  }

  .get-veried-now img {
    width: 6px;
    height: 10px;
  }

  .booking-item-detail span {
    font-size: 12px;
  }

  .yfos-promise-otp-main-wrap {
    padding: 16px 10px;
  }

  .payment-detail-right {
    text-align: right;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .payment-detail-repeat {
    align-items: flex-start;
  }

  .booking-detail-address h6 {
    -webkit-line-clamp: 2;
  }
}

@media (min-width: 1600px) {
  .booking-confirmation-main-wrap {
    height: 724px !important;
    padding-right: 0px;
  }

  .booking-payment-method-wrapper {
    position: relative;
    height: 660px;
    padding-bottom: 0px;
    overflow: auto;
    padding-right: 30px;
  }

  .booking-payment-method-wrapper .pay-button-wrapper {
    padding-top: 9px;
    position: sticky;
    background-color: #fff;
    bottom: 0px;
    width: 100%;
    padding-right: 0px;
    border-top: 1px solid #cccccc40;
  }

  .booking-cart-wrapper {
    min-height: 660px;
    overflow: auto;
  }

  .tracking-order-main-wrap .selected-service-detail-left {
    width: 100%;
    border-right: 1px solid #f3f3f3;
    padding-right: 20px;
    height: 660px;
    overflow: auto;
  }

  .booking-cart-items-wrap {
    margin-top: 34px;
  }

  .booking-cart-item-repeat {
    margin-bottom: 20px;
  }
}

/* @media(min-width: 1920px){
    .booking-cart-wrapper {
        min-height: calc(100vh - 400px) !important;
        overflow: auto;
    }
} */
`, "",{"version":3,"sources":["webpack://./src/components/dashboard/bookingconfirmation.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,yDAAyD;EACzD,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,yDAAqD;EACrD,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;;GAEG;;AAEH;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;;GAIG;;AAEH;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;;kBAEgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;;AAGA;EACE,WAAW;EACX;AACF;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA,2BAA2B;AAC3B;EACE;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,yDAA4D;IAC5D,sBAAsB;IACtB,4BAA4B;IAC5B,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,+BAA+B;EACjC;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;EACb;;EAEA,iDAAiD;EACjD;IACE,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,+BAA+B;IAC/B,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,8BAA8B;IAC9B,+BAA+B;IAC/B,kCAAkC;EACpC;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,yDAAoD;EACtD;;EAEA;IACE,yDAAoD;EACtD;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;AACA;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,UAAU;EACZ;AACF;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA2CG;;AAEH;EACE;IACE,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,yDAAwD;EAC1D;;EAEA;IACE,yDAA4D;IAC5D,sBAAsB;IACtB,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,+BAA+B;EACjC;;EAEA;;;;;;;KAOG;;EAEH;IACE,WAAW;EACb;;EAEA;IACE,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,yDAA8D;EAChE;;EAEA;IACE,yDAA4D;EAC9D;;EAEA;IACE,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,+BAA+B;EACjC;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,+BAA+B;IAC/B,mBAAmB;IACnB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;;;;;GAKG","sourcesContent":[".booking-confirmation-main-wrapper {\n  margin-top: 25px;\n  /* margin-bottom: 20px; */\n}\n\n.booking-confirmation-main-wrap {\n  border: 2px solid #f8f8f8;\n  border-radius: 34px;\n  /* min-height: 72vh; */\n  padding: 30px;\n}\n\n.booking-confirmation-main-wrap {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 40px;\n}\n\n.booking-cart-wrapper {\n  border-right: 1px solid #e1e1e1;\n  padding-right: 16px;\n}\n\n.booking-details-wrapper {\n  border-right: 1px solid #e1e1e1;\n  padding-right: 36px;\n}\n\n.booking-cart-head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.booking-cart-head img {\n  width: 28px;\n  cursor: pointer;\n}\n\n.booking-cart-head img:hover {\n  transform: scale(0.9);\n}\n\n.booking-cart-head h4 {\n  font-size: 18px;\n  color: #1a1919;\n  font-weight: bold;\n  margin: 0px;\n}\n\n.booking-squarefeet-wrap {\n  margin-top: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.booking-squarefeet-wrap p {\n  font-size: 14px;\n  color: #1a1919;\n  font-weight: 400;\n  margin: 0px;\n}\n\n.booking-squarefeet-wrap span {\n  font-size: 14px;\n  color: #1a1919;\n  font-weight: 500;\n  margin: 0px;\n}\n\n.booking-cart-items-wrap {\n  margin-top: 24px;\n}\n\n.booking-cart-items-wrap h5 {\n  font-size: 14px;\n  color: #1a1919;\n  font-weight: 600;\n  margin: 0px;\n}\n\n.booking-cart-item-repeat {\n  display: flex;\n  /* align-items: center; */\n  justify-content: space-between;\n}\n\n.booking-cart-item-left {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 10px;\n}\n\nspan.additional-dropdown-type {\n  font-weight: 600;\n  margin-right: 10px;\n}\n\n.booking-item-image {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background-color: #f3f3f3;\n  overflow: hidden;\n}\n\n.booking-item-image img {\n  width: 100%;\n  object-fit: cover;\n}\n\n.booking-cart-flooring-wrap {\n  margin-top: 12px;\n}\n\n.booking-item-detail {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 5px;\n}\n\n.booking-item-detail h6 {\n  font-size: 14px;\n  color: #1a1919;\n  font-weight: 600;\n  white-space: nowrap;\n  margin: 0px;\n}\n\n.booking-item-detail p {\n  font-size: 14px;\n  color: #1a1919;\n  font-weight: 400;\n  margin: 0px;\n}\n\n.booking-item-detail span {\n  font-size: 14px;\n  color: #00a19b;\n  font-weight: 400;\n  margin-top: 2px;\n}\n\n.booking-cart-item-right {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.update-quantity-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  background: #f3f3f3;\n  border-radius: 12px;\n  min-width: 95px;\n  padding: 2px;\n}\n\n.update-quantity-btn h4 {\n  font-size: 14px;\n  color: #ff0000;\n  font-weight: 600;\n  margin: 0px;\n  cursor: pointer;\n}\n\n.update-quantity-btn span {\n  width: 20px;\n  text-align: center;\n  font-size: 14px;\n  color: #1a1919;\n  font-weight: 600;\n  margin: 0px;\n}\n\n.update-quantity-btn span.percentage-text {\n  width: 30px;\n  text-align: center;\n}\n\n.update-quantity-btn h4.increment-btn-text {\n  color: #20cb00;\n}\n\n.booking-item-price-wrap p {\n  font-size: 14px;\n  color: #1a1919;\n  font-weight: 400;\n  margin: 0px;\n  min-width: 60px;\n}\n\n.booking-cart-item-repeat {\n  margin-bottom: 16px;\n}\n\n.booking-industry-floor-wrap {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0px;\n  margin-top: 22px;\n}\n\n.booking-industry-floor-wrap p {\n  font-size: 14px;\n  color: #00a19b;\n  font-weight: 600;\n  margin: 0px;\n  padding-right: 6px;\n  line-height: normal;\n}\n\n.booking-detail-address-wrap {\n  margin-top: 25px;\n}\n\n.booking-detail-address {\n  margin-top: 17px;\n}\n\n.booking-detail-address p {\n  font-size: 12px;\n  color: #626262;\n  font-weight: 400;\n  margin: 0px;\n}\n\n.booking-detail-address h6 {\n  font-size: 14px;\n  color: #1a1919;\n  font-weight: 500;\n  padding-top: 4px;\n  overflow: hidden;\n  word-break: break-all;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  word-break: break-word;\n}\n\n.contact-person-heading {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 16px;\n}\n\n.contact-person-heading h4 {\n  font-size: 14px;\n  color: #1a1919;\n  font-weight: 600;\n  margin: 0px;\n}\n\n.contact-person-detail-wrap {\n  margin-top: 50px;\n}\n\n.contact-person-booking-detail {\n  margin-top: 32px;\n}\n\n.yfos-promise-main-wrap {\n  width: 100%;\n  height: 247px;\n  border: 1px solid #f3f3f3;\n  border-radius: 9px;\n  padding: 24px 43px;\n  background-image: url(\"../../images/yfos-promise-bg.png\");\n  background-size: cover;\n  background-repeat: no-repeat;\n}\n\n.yfos-promise-otp-main-wrap {\n  background-image: url(\"../../images/yfos-otp-bg.png\");\n  background-size: cover;\n  background-repeat: no-repeat;\n  padding: 22px 43px;\n}\n\n.yfos-promise-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.yfos-promise-head-left h3 {\n  font-size: 30px;\n  color: #1a1919;\n  font-weight: 600;\n  margin: 0px;\n}\n\n.yfos-promise-head-left h4 {\n  font-size: 20px;\n  color: #6b6b6b;\n  font-weight: 600;\n  margin: 0px;\n}\n\n.yfos-promise-head-right img {\n  width: 110px;\n}\n\n.yfos-promise-list-wrap {\n  display: flex;\n  gap: 24px;\n  flex-direction: column;\n  margin-top: 26px;\n}\n\n.yfos-promise-list-repeat {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.yfos-promise-list-repeat p {\n  font-size: 14px;\n  color: #626262;\n  font-weight: 400;\n  margin: 0px;\n}\n\n.yfos-promise-otp-main-wrap {\n  text-align: center;\n}\n\n.commercial-yfos-otp img {\n  width: 66px;\n}\n\n.commercial-otp-heading h3 {\n  font-size: 16px;\n  color: #1a1919;\n  font-weight: 600;\n  margin: 0px;\n}\n\n.commercial-otp-heading {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 18px;\n  margin-top: 16px;\n}\n\n.commercial-otp-heading img {\n  width: 10px;\n  height: 10px;\n  cursor: pointer;\n}\n\n.pay-modal-term-wrapper.yfos-otp-access-wrap {\n  width: 70%;\n  height: 37px;\n  border: 1px solid #f3f3f3;\n  border-radius: 11px;\n  padding: 0px 20px;\n  margin: 0 auto;\n  margin-top: 10px;\n  cursor: pointer;\n}\n\n.pay-modal-term-wrapper.yfos-otp-access-wrap.active {\n  border: 1px solid #00a19b;\n}\n\n.yfos-otp-access-wrap .term-modal-checkmark-wrap {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 37px;\n  gap: 0px;\n  margin-bottom: 0px;\n}\n\n.yfos-otp-access-wrap .term-modal-checkmark-wrap p {\n  font-size: 12px;\n  color: #00a19b;\n  font-weight: 500;\n  margin: 0px;\n}\n\n.yfos-otp-access-wrap .checkbox-container .checkmark {\n  position: absolute;\n  top: -10px;\n  right: -6px;\n  left: unset;\n  height: 18px;\n  width: 18px;\n  background-color: #f3f3f3;\n  border-radius: 0px;\n  border: none;\n  border-radius: 50%;\n}\n\n.yfos-otp-access-wrap .checkbox-container .checkmark:after {\n  left: 7px;\n  top: 3px;\n  width: 5px;\n  height: 10px;\n}\n\n.payment-saved-card-info {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  height: 62px;\n}\n\n.add-payment-card-info {\n  justify-content: space-between;\n}\n\n.payment-saved-card-info img {\n  width: 35px;\n}\n\n.payment-saved-card-info p {\n  font-size: 12px;\n  color: #1a1919;\n  font-weight: 500;\n  margin: 0px;\n}\n\n.payment-saved-card-wrap {\n  width: 100%;\n  height: 62px;\n  border: 1px solid #f3f3f3;\n  border-radius: 9px;\n  margin-top: 10px;\n  padding: 0px 20px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.payment-save-card-right p {\n  font-size: 12px;\n  color: #1a1919;\n  font-weight: 500;\n  margin: 0px;\n}\n\n.payment-save-card-right img {\n  width: 25px;\n}\n\n.add-card-left-wrap {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n}\n\n.add-card-left-wrap img {\n  width: 34px;\n}\n\n.postpaid-payment-left-wrap {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.postpaid-payment-main-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid #f3f3f3;\n  border-radius: 9px;\n  background: #f3f3f3;\n  padding: 0px 20px;\n  height: 62px;\n  margin-top: 12px;\n}\n\n.approved-postpaid-payment-main-wrap {\n  background-color: #fff;\n  border: 1px solid #f3f3f3;\n  cursor: pointer;\n}\n\n.approved-postpaid-payment-main-wrap.active {\n  border: 1px solid #00a19b;\n}\n\n.postpaid-payment-left-wrap img {\n  width: 30px;\n}\n\n.postpaid-payment-left-wrap p {\n  font-size: 12px;\n  color: #1a1919;\n  font-weight: 500;\n  margin: 0px;\n}\n\n.postpaid-payment-right-wrap p {\n  font-size: 12px;\n  color: #00a19b;\n  font-weight: 500;\n  margin: 0px;\n  cursor: pointer;\n}\n\n.postpaid-payment-right-wrap {\n  display: flex;\n  gap: 24px;\n}\n\n.get-veried-now {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.offer-and-benefits-wrap {\n  margin-top: 12px;\n  /* margin-top: 20px; */\n}\n\n.offer-and-benefits-wrap h4 {\n  font-size: 14px;\n  color: #1a1919;\n  font-weight: 500;\n  padding-left: 10px;\n  margin: 0px;\n}\n\n.apply-coupon-wrap {\n  width: 100%;\n  height: 62px;\n  border: 1px solid #f3f3f3;\n  border-radius: 9px;\n  padding: 0px 20px;\n  margin-top: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n}\n\n/* .apply-coupon-wrap:hover{\n    border: 1px solid #00A19B;\n} */\n\n.apply-coupon-wrap p {\n  font-size: 12px;\n  color: #1a1919;\n  font-weight: 500;\n  margin: 0px;\n}\n\n.apply-coupon-wrap img {\n  width: 7px;\n}\n\n.payment-method-detail-wrap {\n  margin-top: 18px;\n  border-bottom: 1px dashed #e1e1e1;\n}\n\n.payment-detail-left p {\n  font-size: 14px;\n  color: #1a1919;\n  font-weight: 500;\n  margin: 0px;\n}\n\n.payment-detail-right p {\n  font-size: 14px;\n  color: #626262;\n  font-weight: 400;\n  margin: 0px;\n}\n\n.payment-detail-repeat {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.payment-detail-right {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  text-align: right;\n  gap: 2px;\n}\n\n.payment-method-price-detail-wrap {\n  margin-top: 12px;\n  margin-bottom: 12px;\n}\n\n.payment-detail-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.payment-detail-left h4 {\n  font-size: 16px;\n  color: #1a1919;\n  font-weight: 600;\n  margin: 0px;\n}\n\n.payment-detail-right h4 {\n  font-size: 16px;\n  color: #00a19b;\n  font-weight: 600;\n  margin: 0px;\n}\n\nspan.extra-item-size-text {\n  font-weight: 500;\n  color: #1a1919;\n  margin-left: 3px;\n}\n\n.edit-extra-item-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  cursor: pointer;\n  background: #daf6f6;\n  border-radius: 12px;\n  min-width: 95px;\n  padding: 2px;\n}\n\n.edit-extra-item-btn p {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1a1919;\n  margin: 0px;\n}\n\n.additional-dropdown-shows {\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n\n.mobile-text {\n  display: none;\n}\n\n.cart-drawer-main-wrapper .decrement-btn-text img {\n  width: 20px;\n  height: 17px;\n}\n\n.contact-person-heading img {\n  cursor: pointer;\n  width: 10px;\n  height: 10px;\n}\n\n.payment-detail-left img {\n  cursor: pointer;\n}\n\n.payment-saved-card-wrap.active {\n  border: 1px solid #00a19b;\n}\n\n.payment-saved-card-wrap {\n  cursor: pointer;\n}\n\n.payment-schedule-date {\n  display: flex;\n  align-items: center;\n  gap: 0px;\n}\n\n/* .exterior-window-li {\n    display: flex;\n    width: 100%;\n    flex-wrap: wrap;\n} */\n\n.exterior-dropdown-type-main-wrap li {\n  list-style: none;\n  margin-right: 10px;\n}\n\n.exterior-dropdown-type-main-wrap {\n  /* display: flex;\n    justify-content: space-between;\n    width: 100%; */\n}\n\n.number-of-window {\n  margin-top: 10px;\n}\n\np.exterior-service-head {\n  font-size: 16px;\n  color: #00a19b;\n}\n\n.specialty-booking-item-detail {\n  display: flex;\n  flex-direction: column;\n}\n\n.payment-detail-repeat.total-payment-detail-repeat {\n  background: #fff;\n  margin-bottom: 0px;\n  padding-bottom: 8px;\n}\n\n\nimg.payment-method-postpaid-icon{\n  width: 18px;\n  margin-right: 4px\n}\n\n\nimg.payment-method-cart-icon{\n  margin-top: -3px;\n}\n\n.payment-saved-card-wrap:hover{\n  border: 1px solid #00a19b;\n}\n\n.approved-postpaid-payment-main-wrap:hover{\n  border: 1px solid #00a19b;\n}\n\n.apply-coupon-wrap:hover{\n  border: 1px solid #00a19b; \n}\n\n\n/******* Resposive css ****/\n@media (max-width: 1024px) {\n  .booking-confirmation-main-wrap {\n    display: grid;\n    grid-template-columns: repeat(1, 1fr);\n    gap: 18px;\n    border: unset;\n    border-radius: 0px;\n    min-height: unset;\n    padding: 0px;\n  }\n\n  .yfos-promise-main-wrapper {\n    display: none;\n  }\n\n  .yfos-promise-otp-main-wrapper {\n    display: block;\n  }\n\n  .yfos-promise-otp-main-wrap {\n    background-image: url(\"../../images/laptop-yfos-otp-bg.png\");\n    background-size: cover;\n    background-repeat: no-repeat;\n    padding: 20px;\n    height: 154px;\n    margin-top: 20px;\n    /* margin-bottom: 10px; */\n  }\n\n  .commercial-otp-heading h3 {\n    font-size: 14px;\n  }\n\n  .pay-modal-term-wrapper.yfos-otp-access-wrap {\n    width: 90%;\n    margin-top: 12px;\n  }\n\n  .commercial-otp-heading {\n    margin-bottom: 12px;\n    margin-top: 0px;\n  }\n\n  .commercial-yfos-otp {\n    display: none;\n  }\n\n  .booking-details-wrapper {\n    border-right: unset;\n    padding-right: 0px;\n    /* margin-top: 30px; */\n    margin-top: 10px;\n  }\n\n  .booking-cart-head h4 {\n    font-size: 18px;\n    font-weight: 600;\n  }\n\n  .contact-person-booking-detail .field {\n    position: relative;\n    width: 100%;\n    margin-bottom: 14px;\n  }\n\n  .payment-detail-left p {\n    min-width: 80px;\n  }\n\n  .payment-detail-right {\n    text-align: right;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n  }\n\n  .payment-detail-repeat {\n    align-items: flex-start;\n  }\n\n  .booking-confirmation-main-wrapper {\n    margin-bottom: 40px;\n  }\n\n  .payment-detail-right img {\n    width: 25px;\n  }\n\n  .pay-mobile-button-wrapper {\n    margin-top: 22px;\n    position: sticky;\n    z-index: 999;\n    bottom: 80px;\n    background: #fff;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    border-top: 1px solid #cccccc40;\n  }\n\n  .pay-button-wrapper button {\n    height: 62px;\n    font-size: 18px;\n  }\n\n  .payment-method-detail-wrap {\n    margin-top: 26px;\n    padding-bottom: 6px;\n  }\n\n  .desktop-text {\n    display: none;\n  }\n\n  .mobile-text {\n    display: block;\n  }\n\n  .offer-and-benefits-wrap {\n    margin-top: 26px;\n  }\n\n  .postpaid-payment-right-wrap {\n    gap: 10px;\n  }\n\n  .postpaid-payment-left-wrap img {\n    width: 34px;\n  }\n\n  .contact-person-heading {\n    /* margin-bottom: 10px; */\n    margin-bottom: 16px;\n  }\n\n  .contact-person-booking-detail {\n    margin-top: 40px;\n  }\n\n  .booking-detail-address {\n    margin-top: 20px;\n  }\n\n  .booking-detail-address-wrap {\n    margin-top: 32px;\n  }\n\n  .booking-cart-head img {\n    width: 27px;\n  }\n\n  .booking-cart-items-wrap h5 {\n    font-size: 18px;\n  }\n\n  .mobile-booking-cart-items-wrap {\n    margin-top: 30px;\n  }\n\n  .mobile-booking-cart-items-wrap h5 {\n    font-size: 18px;\n    color: #1a1919;\n    font-weight: 600;\n    margin: 0px;\n  }\n\n  /********************** Select Services css *****/\n  .accordion-item {\n    margin-bottom: 16px;\n  }\n\n  .accordion-item .accordion-header .accordion-button {\n    border-bottom-left-radius: 0px;\n    border-bottom-right-radius: 0px;\n    padding: 10px 20px;\n  }\n\n  .accordion-button:not(.collapsed) {\n    color: unset;\n    background-color: unset;\n    box-shadow: unset;\n  }\n\n  .accordion-item {\n    border-radius: 9px;\n    border: 1px solid #f3f3f3;\n  }\n\n  .accordion-item .accordion-collapse.collapse.show {\n    border-top: none;\n    border-bottom-left-radius: 9px;\n    border-bottom-right-radius: 9px;\n    transition: border-color 0.3s ease;\n  }\n\n  .accordion-button:not(.collapsed) {\n    border-radius: 9px;\n    border-bottom: none;\n  }\n\n  .accordion-button:focus {\n    box-shadow: none;\n  }\n\n  .accordion-item:not(:first-of-type) {\n    border-top: 1px solid #f3f3f3;\n  }\n\n  .accordion-item.active {\n    border: 2px solid #00a19b;\n  }\n\n  button.accordion-button img {\n    width: 56px;\n    margin-right: 20px;\n  }\n\n  button.accordion-button {\n    position: unset;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px !important;\n    font-size: 14px;\n    font-weight: 600;\n    color: #1a1919 !important;\n  }\n\n  .accordion-item {\n    position: relative;\n    border-radius: 10px !important;\n  }\n\n  .accordion-button::after {\n    position: absolute;\n    bottom: -10px;\n    right: 10px;\n    background-image: url(\"../../images/down-arrow.png\");\n  }\n\n  .accordion-button:not(.collapsed)::after {\n    background-image: url(\"../../images/down-arrow.png\");\n  }\n\n  .mobile-booking-cart-item-left {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .update-quantity-btn {\n    width: 100px;\n    gap: 16px;\n  }\n\n  .edit-extra-item-btn {\n    width: 100px;\n  }\n\n  .edit-extra-item-btn p {\n    font-weight: 500;\n  }\n\n  .booking-cart-item-repeat {\n    display: flex;\n    align-items: flex-start;\n  }\n\n  .booking-item-detail p {\n    text-align: left;\n    width: 100%;\n  }\n\n  .booking-squarefeet-wrap {\n    margin-top: 30px;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .booking-cart-flooring-wrap {\n    margin-top: 14px;\n  }\n\n  .mobile-accordion-body-wrapper {\n    margin-top: -8px;\n  }\n\n  .booking-industry-floor-wrap p {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 360px) {\n}\n\n@media (max-width: 330px) {\n  .payment-detail-left p {\n    min-width: 50px;\n  }\n\n  .payment-detail-right img {\n    width: 24px;\n  }\n\n  .payment-detail-right {\n    gap: 0px;\n  }\n\n  .postpaid-payment-right-wrap {\n    gap: 2px;\n  }\n\n  .postpaid-payment-left-wrap {\n    gap: 4px;\n  }\n\n  .postpaid-payment-right-wrap p {\n    font-size: 10px;\n  }\n\n  .get-veried-now {\n    gap: 3px;\n  }\n\n  .get-veried-now img {\n    width: 4px;\n  }\n}\n/* \n@media (min-width: 768px) and (max-width: 1024px) {\n    .booking-confirmation-main-wrap {\n        grid-template-columns: repeat(1, 1fr);\n        gap: 20px;\n        border-radius: 24px;\n        padding: 30px 0px;\n        border: none;\n    }\n\n    .booking-details-wrapper {\n        padding-right: 0px;\n        border-right: none;\n    }\n\n    .yfos-promise-main-wrap {\n        display: none;\n    }\n\n    .booking-cart-wrapper {\n        border-right: none;\n        padding-right: 0px;\n    }\n\n    p.desktop-text {\n        display: none;\n    }\n\n    .mobile-text {\n        display: block;\n    }\n\n    .payment-detail-left {\n        min-width: 100px;\n    }\n\n    .payment-detail-right {\n        text-align: right;\n    }\n\n    .offer-and-benefits-wrap {\n        margin-top: 16px;\n    }\n} */\n\n@media (min-width: 1025px) and (max-width: 1599px) {\n  .booking-confirmation-main-wrap {\n    gap: 20px;\n    border-radius: 24px;\n    padding: 22px 20px;\n    height: 525px;\n    padding-right: 0px;\n  }\n\n  .booking-confirmation-main-wrapper {\n    margin-top: 16px;\n  }\n\n  .booking-details-wrapper {\n    padding-right: 20px;\n  }\n\n  .booking-cart-item-repeat {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    flex-direction: column;\n    gap: 6px;\n    margin-bottom: 14px;\n  }\n\n  p.desktop-text {\n    display: none;\n  }\n\n  .mobile-text {\n    display: block;\n  }\n\n  .payment-detail-left {\n    min-width: 50px;\n  }\n\n  .payment-detail-right {\n    gap: 0px;\n  }\n\n  .payment-detail-right {\n    text-align: right;\n  }\n\n  .offer-and-benefits-wrap {\n    margin-top: 8px;\n  }\n\n  .yfos-promise-head-right img {\n    width: 80px;\n  }\n\n  .yfos-promise-head-left h3 {\n    font-size: 24px;\n  }\n\n  .yfos-promise-head-left h4 {\n    font-size: 16px;\n  }\n\n  .yfos-promise-head-left {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n\n  .yfos-promise-list-wrap {\n    margin-top: 15px;\n    gap: 10px;\n  }\n\n  .yfos-promise-list-repeat img {\n    width: 15px;\n    height: 15px;\n  }\n\n  .yfos-promise-list-repeat p {\n    font-size: 12px;\n  }\n\n  .yfos-promise-main-wrap {\n    height: 150px;\n    padding: 16px 36px;\n    background-image: url(\"../../images/laptop-yfos-bg.png\");\n  }\n\n  .yfos-promise-otp-main-wrap {\n    background-image: url(\"../../images/laptop-yfos-otp-bg.png\");\n    background-size: cover;\n    background-repeat: no-repeat;\n    padding: 16px 20px;\n  }\n\n  .commercial-otp-heading h3 {\n    font-size: 14px;\n  }\n\n  .pay-modal-term-wrapper.yfos-otp-access-wrap {\n    width: 90%;\n  }\n\n  .commercial-otp-heading {\n    margin-bottom: 10px;\n    margin-top: 0px;\n  }\n\n  .commercial-yfos-otp {\n    display: none;\n  }\n\n  .booking-cart-head h4 {\n    font-size: 14px;\n  }\n\n  .booking-detail-address {\n    margin-top: 16px;\n  }\n\n  .booking-cart-head {\n    gap: 8px;\n  }\n\n  .booking-cart-head img {\n    width: 22px;\n  }\n\n  .booking-squarefeet-wrap {\n    margin-top: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .booking-cart-items-wrap {\n    margin-top: 22px;\n  }\n\n  .booking-squarefeet-wrap span {\n    font-size: 12px;\n  }\n\n  .booking-squarefeet-wrap p {\n    font-size: 12px;\n  }\n\n  .booking-cart-items-wrap h5 {\n    font-size: 12px;\n  }\n\n  .booking-item-detail h6 {\n    font-size: 12px;\n  }\n\n  .booking-item-detail p {\n    font-size: 12px;\n  }\n\n  .booking-cart-wrapper {\n    min-height: 480px !important;\n    overflow: auto;\n  }\n\n  .update-quantity-btn {\n    min-width: 74px;\n    padding: 2px;\n  }\n\n  .update-quantity-btn span {\n    font-size: 10px;\n  }\n\n  .update-quantity-btn span.percentage-text {\n    width: 22px;\n  }\n\n  .booking-item-price-wrap p {\n    font-size: 12px;\n  }\n\n  .booking-industry-floor-wrap p {\n    font-size: 12px;\n  }\n\n  .booking-industry-floor-wrap img {\n    width: 22px;\n  }\n\n  .booking-industry-floor-wrap {\n    margin-top: 10px;\n  }\n\n  .booking-detail-address-wrap {\n    margin-top: 16px;\n  }\n\n  .booking-detail-address h6 {\n    font-size: 12px;\n  }\n\n  .contact-person-heading h4 {\n    font-size: 12px;\n  }\n\n  .contact-person-booking-detail {\n    margin-top: 20px;\n  }\n\n  .contact-person-heading {\n    margin-bottom: 10px;\n  }\n\n  .contact-person-booking-detail .field {\n    margin-bottom: 16px;\n  }\n\n  .payment-saved-card-wrap {\n    height: 48px;\n  }\n\n  .booking-payment-method-wrapper {\n    position: relative;\n    max-height: 500px;\n    overflow: auto;\n    padding-right: 20px;\n  }\n\n  .booking-payment-method-wrapper .pay-button-wrapper {\n    position: sticky;\n    bottom: 0px;\n    width: 100%;\n    background-color: #fff;\n    padding-top: 6px;\n    border-top: 1px solid #cccccc40;\n  }\n\n  /* .total-payment-detail-repeat{\n    position: sticky;\n    bottom: 80px;\n    width: 100%;\n    background-color: #fff; \n    padding-bottom: 10px;\n    margin-bottom: 0px;\n  } */\n\n  .payment-saved-card-info img {\n    width: 30px;\n  }\n\n  .payment-saved-card-info {\n    gap: 6px;\n    height: 48px;\n  }\n\n  .add-card-left-wrap img {\n    width: 26px;\n  }\n\n  .add-card-left-wrap {\n    gap: 5px;\n  }\n\n  .postpaid-payment-main-wrap {\n    height: 48px;\n    margin-top: 8px;\n  }\n\n  .apply-coupon-wrap {\n    height: 48px;\n    margin-top: 8px;\n  }\n\n  .offer-and-benefits-wrap h4 {\n    font-size: 12px;\n  }\n\n  .payment-detail-left p {\n    font-size: 12px;\n  }\n\n  .payment-detail-right p {\n    font-size: 12px;\n  }\n\n  .payment-detail-left h4 {\n    font-size: 14px;\n  }\n\n  .payment-detail-right h4 {\n    font-size: 14px;\n  }\n\n  .payment-detail-repeat {\n    margin-bottom: 4px;\n  }\n\n  .payment-method-detail-wrap {\n    margin-top: 8px;\n  }\n\n  .payment-detail-right img {\n    width: 22px;\n    height: 22px;\n  }\n\n  img.payment-method-postpaid-icon {\n    width: 18px;\n    height: 18px;\n    margin-right: 4px;\n}\n\n  .payment-method-price-detail-wrap {\n    margin-top: 5px;\n  }\n\n  .pay-button-wrapper {\n    margin-top: 8px;\n  }\n\n  .booking-confirmation-main-wrap .booking-cart-item-right-wrapper {\n    width: 100%;\n  }\n\n  .booking-cart-item-right {\n    justify-content: flex-end;\n    text-align: right;\n    gap: 0px;\n  }\n\n  .booking-item-detail span {\n    font-size: 12px;\n  }\n\n  .payment-method-price-detail-wrap {\n    margin-bottom: 0px;\n  }\n}\n\n@media (min-width: 1025px) and (max-width: 1199px) {\n  .yfos-promise-main-wrap {\n    background-image: url(\"../../images/small-laptop-yfos-bg.png\");\n  }\n\n  .yfos-promise-otp-main-wrap {\n    background-image: url(\"../../images/laptop-yfos-otp-bg.png\");\n  }\n\n  .booking-confirmation-main-wrap {\n    gap: 10px;\n    border-radius: 24px;\n    padding: 16px 20px;\n    padding-right: 0px;\n  }\n\n  .booking-details-wrapper {\n    padding-right: 10px;\n  }\n\n  .booking-payment-method-wrapper {\n    padding-right: 10px;\n  }\n\n  .payment-saved-card-info img {\n    width: 22px;\n  }\n\n  .payment-saved-card-info p {\n    font-size: 11px;\n  }\n\n  .payment-save-card-right p {\n    font-size: 11px;\n  }\n\n  .payment-saved-card-info {\n    gap: 2px;\n  }\n\n  .add-card-left-wrap img {\n    width: 26px;\n  }\n\n  .add-card-left-wrap {\n    gap: 2px;\n  }\n\n  .postpaid-payment-right-wrap p {\n    font-size: 10px;\n  }\n\n  .postpaid-payment-left-wrap p {\n    font-size: 11px;\n  }\n\n  .postpaid-payment-left-wrap {\n    gap: 4px;\n  }\n\n  .postpaid-payment-right-wrap {\n    gap: 10px;\n  }\n\n  .get-veried-now img {\n    width: 6px;\n    height: 10px;\n  }\n\n  .booking-item-detail span {\n    font-size: 12px;\n  }\n\n  .yfos-promise-otp-main-wrap {\n    padding: 16px 10px;\n  }\n\n  .payment-detail-right {\n    text-align: right;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n  }\n\n  .payment-detail-repeat {\n    align-items: flex-start;\n  }\n\n  .booking-detail-address h6 {\n    -webkit-line-clamp: 2;\n  }\n}\n\n@media (min-width: 1600px) {\n  .booking-confirmation-main-wrap {\n    height: 724px !important;\n    padding-right: 0px;\n  }\n\n  .booking-payment-method-wrapper {\n    position: relative;\n    height: 660px;\n    padding-bottom: 0px;\n    overflow: auto;\n    padding-right: 30px;\n  }\n\n  .booking-payment-method-wrapper .pay-button-wrapper {\n    padding-top: 9px;\n    position: sticky;\n    background-color: #fff;\n    bottom: 0px;\n    width: 100%;\n    padding-right: 0px;\n    border-top: 1px solid #cccccc40;\n  }\n\n  .booking-cart-wrapper {\n    min-height: 660px;\n    overflow: auto;\n  }\n\n  .tracking-order-main-wrap .selected-service-detail-left {\n    width: 100%;\n    border-right: 1px solid #f3f3f3;\n    padding-right: 20px;\n    height: 660px;\n    overflow: auto;\n  }\n\n  .booking-cart-items-wrap {\n    margin-top: 34px;\n  }\n\n  .booking-cart-item-repeat {\n    margin-bottom: 20px;\n  }\n}\n\n/* @media(min-width: 1920px){\n    .booking-cart-wrapper {\n        min-height: calc(100vh - 400px) !important;\n        overflow: auto;\n    }\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
